import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ClienteService {
  constructor(private http: HttpClient) {}

  getClientInfo() {
    return this.http.get<any>('cliente/user');
  }

  getMerchants() {
    return this.http.get<any[]>('cliente/merchant');
  }

  getCheckouts(merchantId: string) {
    return this.http.get<any>(`cliente/checkout?merchantId=${merchantId}`);
  }

  registerCheckout(merchantId: string, checkoutLabel: string) {
    return this.http.post(
      `cliente/checkout?merchantId=${merchantId}&checkoutLabel=${checkoutLabel}`,
      null,
    );
  }

  //#region Terminal
  getTerminals(merchantId: string, checkoutId: string) {
    return this.http.get<any>(`cliente/terminal?merchantId=${merchantId}&checkoutId=${checkoutId}`);
  }
  clearTerminalStatus(merchantId: string, linker: string) {
    return this.http.get<any>(`cliente/terminal/clear?merchantId=${merchantId}&linker=${linker}`);
  }
  //#endregion

  updateToken(merchantId: string) {
    return this.http.post(`cliente/updateToken?merchantId=${merchantId}`, null);
  }
}
